module.exports = __webpack_public_path__ + "static/media/results.d21fe130.PNG";